<template lang="pug">
  .module__main
    .module__title Мониторинг активности
    .module-content__container(v-loading="isLoading")
      .filters__container
        .dates__container
          .date__container
            .date__title От
            el-date-picker(
              v-model="timeFrom"
              type="datetime"
              value-format="timestamp"
            )
          .date__container
            .date__title До
            el-date-picker(
              v-model="timeTo"
              type="datetime"
              value-format="timestamp"
            )
        el-button(type="primary" @click="startLoadStats()" :disabled="isLoading") Запросить
      .stats__container
        .stats__chart
          BarChart(:chartData="ordersStats" :listenEvents="true" @showUserOrdersIds="this.showUserOrdersIds" chartId="orders-stats")
        .stats__chart
          BarChart(:chartData="otherStats" chartId="other-stats")
    el-dialog(:visible.sync="ordersChartDetails.show" :before-close="resetShowOrdersChartDetails" :title="showOrdersChartDetailsTitle" width="30%")
      .orders-ids__list
        .order__id(v-for="(id, index) in ordersChartDetails.ids" :key="`orders-chart-order-id-${id}-${index}`") {{ id }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { LOAD_ACTIONS_STATS } from "../../store/const/settings";
import BarChart from './BarChart'

export default {
  name: 'ActionsStats',
  components: { BarChart },
  data() {
    return {
      timeFrom: null,
      timeTo: null,
      ordersChartDetails: {
        show: false,
        label: '',
        user: '',
        ids: [],
      },
    }
  },
  computed: {
    ...mapGetters([
      'loading',
      'error',
    ]),
    ...mapGetters('settings', [
      'actionsStats',
    ]),
    isLoading() {
      return this.loading(LOAD_ACTIONS_STATS) === 'loading';
    },
    ordersStats() {
      let data = {
        labels: [],
        datasets: [
          {
            label: 'Завершено заявок',
            labelName: 'orders_finished',
            data: [],
            backgroundColor: '#ff7f50'
          },
          {
            label: 'Открыто претензий',
            labelName: 'claims_added',
            data: [],
            backgroundColor: '#87ceeb'
          },
          {
            label: 'Отменено претензий',
            labelName: 'claims_canceled',
            data: [],
            backgroundColor: '#90ee90'
          },
        ]
      };

      for(let i = 0; i < this.actionsStats.length; i++) {
        let user = this.actionsStats[i];
        data.labels.push(user.username);
        data.datasets[0].data.push(user.orders_finished.amount);
        data.datasets[1].data.push(user.claims_added.amount);
        data.datasets[2].data.push(user.claims_canceled.amount);
      }
      return data;
    },
    otherStats() {
      let data = {
        labels: [],
        datasets: [
          {
            label: 'Добавлено в черный список',
            data: [],
            backgroundColor: '#cb7ae9'
          },
        ]
      };

      for(let i = 0; i < this.actionsStats.length; i++) {
        let user = this.actionsStats[i];
        data.labels.push(user.username);
        data.datasets[0].data.push(user.blacklist_added);
      }

      return data;
    },
    showOrdersChartDetailsTitle() {
      return `Список ID ${this.ordersChartDetails.label} пользователя ${this.ordersChartDetails.user}`;
    }
  },
  methods: {
    ...mapActions('settings', {
      loadStats: LOAD_ACTIONS_STATS,
    }),
    async startLoadStats() {
      await this.loadStats({ from: this.timeFrom, to: this.timeTo });
    },
    showUserOrdersIds({ type, user, label }) {
      const userStats = this.actionsStats.find((stat) => stat.username === user);
      if (userStats) {
        this.ordersChartDetails.label = label;
        this.ordersChartDetails.user = user;
        this.ordersChartDetails.ids = userStats[type].ids;
        this.ordersChartDetails.show = true;
      }
    },
    resetShowOrdersChartDetails() {
      this.ordersChartDetails.show = false;
    },
  }
};
</script>
<style scoped>
.stats__container {
  overflow-y: scroll;
}
.stats__chart {
  margin: 5px auto;
  padding: 5px;
  background-color: #efefef;
}
.filters__container {
  display: flex;
  padding: 5px;
  background-color: #efefef;
  align-content: center;
}

.dates__container {
  display: flex;
  align-items: center;
}

.date__container {
  margin: 0 5px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.date__title {
  margin-right: 5px;
  font-size: 12px;
  font-weight: bold;
}

</style>
